import React from 'react'

import '../../scss/organisms/Footer.scss'

const Footer = () => {
    return (
      <div className="footer">
        <p>
          Datos de fuentes oficiales de la NASA
        </p>
        <p>
          Hecho con <span role="img" aria-label="amor">❤️</span> por T-<span>REX</span>PACE
        </p>
      </div>
    )
}

export default Footer